import { memo, useMemo } from 'react'
import { useFormState } from 'react-final-form'
import cn from 'classnames'
import { SUPPORT_TEL, SUPPORT_TEL_FORMATTED } from 'constants/links'
import IconAlert from 'remixicon/icons/System/alert-fill.svg?react'

import { isOutLimitCargoTotal } from '../../helpers/order'
import { IOrderCreateFormData } from '../../types/orderGuestCreateTypes'
import { VOLUME_LIMIT, WEIGHT_LIMIT_IN_TONNE } from './constants'

interface IProps {
  className?: string
}

export const OrderCargoTotalWarning = memo<IProps>(function OrderCargoTotalWarning({ className }) {
  const { values } = useFormState<IOrderCreateFormData>()
  const { cargoTotal, customer } = values
  const hasSpecialCargoLimits = customer?.hasSpecialCargoLimits
  const isShowWarning = cargoTotal && isOutLimitCargoTotal(cargoTotal)

  const message = useMemo(
    () => (
      <>
        Для отправки груза, общий объём/вес которого превышает {VOLUME_LIMIT}&nbsp;м3&nbsp;/&nbsp;
        {WEIGHT_LIMIT_IN_TONNE}&nbsp;т, свяжитесь{' '}
        {hasSpecialCargoLimits ? (
          <>со&nbsp;своим проектным менеджером</>
        ) : (
          <>
            с&nbsp;нами по&nbsp;телефону{' '}
            <a className="link" href={`tel:${SUPPORT_TEL}`}>
              {SUPPORT_TEL_FORMATTED}
            </a>
          </>
        )}
      </>
    ),
    [hasSpecialCargoLimits]
  )

  return isShowWarning ? (
    <div
      className={cn(className, 'mt-2 grid grid-cols-[auto_1fr] items-start gap-x-4 rounded bg-negative-container p-3')}
    >
      <IconAlert className="text-on-negative-container" containerSize="nm" size="xs" />
      <div className="text-on-surface">{message}</div>
    </div>
  ) : null
})
